var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.headers),function(header){return _c('td',{key:header.text},[(header.value === _vm.options.totalCalculate.titleField)?_c('b',{class:{'shadow': _vm.shadowTotalTitle}},[_vm._v(_vm._s(_vm.fmt(_vm.rowData[header.value])))]):[_vm._v(_vm._s(_vm.fmt(_vm.rowData[header.value])))]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }